export default function beautifyLabel(
  input: unknown,
  isOnlyFistLetterCapital = false
): string {
  // Validate the input is a non-empty string
  if (typeof input !== 'string' || input.trim() === '') {
    return '';
  }

  // Step 1: Trim unwanted characters from beginning and end
  const cleaned = input.trim().replace(/^[^a-zA-Z0-9]+|[^a-zA-Z0-9]+$/g, '');

  // Step 2: Replace underscores and hyphens with spaces
  let spaced = cleaned.replace(/[_-]+/g, ' ');

  // Step 3: Add spaces before capital letters in camelCase
  spaced = spaced.replace(/([a-z])([A-Z])/g, '$1 $2');

  // Step 4: Convert to lowercase and capitalize the first letter of each word
  const result = spaced
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());

  if (isOnlyFistLetterCapital) {
    return result?.charAt(0)?.toUpperCase() + result?.slice(1)?.toLowerCase();
  } else {
    return result;
  }
}
